import { useState, useEffect } from 'react';
import { PremiumPaywallSignModes, SiteLinks, PaywallPlans } from "../../../../global/paywall/paywallInterfaces"
import { PremiumPaywallDesktopSignin } from './premiumPaywallDesktopSignin';
import { PremiumPaywallDesktopSignup } from "./premiumPaywallDesktopSignup"
import { useRedirect } from '../../../../global/paywall/useRedirect';
import { LegalLink } from '../mobile/premiumPaywallMobile';


interface PremiumPaywallDesktopProps {
  legalLinks: {
    terms: LegalLink;
    privacy: LegalLink;
}
  setIsRedirecting?: (isRedirect: boolean) => void;
  mode?: PremiumPaywallSignModes;
}

export interface PremiumPaywallState {
  mode: PremiumPaywallSignModes;
  isNewspaper?: boolean;
}


export const PremiumPaywallDesktop = (props: PremiumPaywallDesktopProps) => {
  const [authMode, setAuthMode] = useState<PremiumPaywallState>({
    mode: props.mode || 'signUp',
    isNewspaper: false,
  });
  const [emailOrPhone, setEmailOrPhone] = useState<string>('');
  const [agreesTerms, setAgreeTerms] = useState(false);
  const [password, setPassword] = useState('');
  const [isRedirecting, setIsRedirecting] = useState(false);
  useRedirect({ enabled: isRedirecting });
  const { mode } = props;

  useEffect(() => {
    if (mode !== undefined) {
      setAuthMode({ mode, isNewspaper: false });
    }
  }, [mode]);


  const getFormByMode = () => {
    if (authMode.mode === 'signUp') {
      return (
        <PremiumPaywallDesktopSignup
          emailOrPhone={emailOrPhone}
          password={password}
          agreesTerms={agreesTerms}
          setEmailOrPhone={setEmailOrPhone}
          setPassword={setPassword}
          setAgreesTerms={setAgreeTerms}
          setMode={setAuthMode}
          setIsRedirecting={setIsRedirecting}
        />
      );
    }
    return (
      <PremiumPaywallDesktopSignin
        emailOrPhone={emailOrPhone}
        password={password}
        agreesTerms={agreesTerms}
        setEmailOrPhone={setEmailOrPhone}
        setPassword={setPassword}
        setAgreesTerms={setAgreeTerms}
        setMode={setAuthMode}
        setIsRedirecting={setIsRedirecting}
        isNewspaper={authMode.isNewspaper}
        
      />);
  };

  return <div className="premium-paywall-desktop">{getFormByMode()}</div>;
};
